import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { CountyComponent } from './county.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'administration/facilitiesAndAgencies',
        children: [
          { path: 'county', component: CountyComponent, data: { title: 'County'} }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CountyRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/county/county-routing.module.ts